import { useEffect, useRef, useState } from "react";
import "./addingModal.css";
import plusIcon from "../icons/plus.png";
import houseIcon from "../icons/house.png";
import whiteHouseIcon from "../icons/white-house.png";
import userWhiteIcon from "../icons/user-white.png";
import userBlackIcon from "../icons/user-black.png";
import sendIcon from "../icons/plane.png";
import { setFontSize } from "../utils/fonts";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";

const AddingModal = ({ setNewItems, newItems, isUsers, setModalOpened }) => {
  const {
    locations,
    setLocations,
    users,
    setUsers,
    baseUrl,
    apiKey,
    loggedUser,
  } = useGlobalContext();

  const [items, setItems] = useState(isUsers ? users : locations);

  const wrapperRef = useRef();
  const inputRef = useRef();

  const setItemHeight = () => {
    const wrapperDim = wrapperRef.current.getBoundingClientRect();
    const modalItems =
      wrapperRef.current.querySelectorAll(".adding-modal-item");
    modalItems.forEach(
      (item) => (item.style.height = `${wrapperDim.height / 4}px`)
    );
    const nameSpans = wrapperRef.current.querySelectorAll(
      ".adding-modal-item-name"
    );
    nameSpans.forEach((span) => setFontSize(span, 2));
    setFontSize(inputRef.current, 2);
  };

  window.addEventListener("resize", setItemHeight);

  const checkIfItemExists = (name) =>
    newItems.find((item) => item.name === name);

  const getIcon = (fromLocation) => {
    if (isUsers && fromLocation) return userBlackIcon;
    if (isUsers && !fromLocation) return userWhiteIcon;
    if (fromLocation) return houseIcon;
    return whiteHouseIcon; // treba bela ikona da se stavi
  };

  const addItems = () => {
    const allItems = wrapperRef.current.querySelectorAll(
      ".adding-modal-item-checkbox"
    );
    const newAddedItems = items.filter((_, index) =>
      allItems[index].classList.contains("exist")
    );
    setNewItems(newAddedItems);
    setModalOpened(false);
  };

  const addNewItem = async () => {
    const name = inputRef.current.value;
    if (name === "") return;
    let newItem = {
      fromLocation: false,
      name,
    };
    if (isUsers) {
      try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/notebook/createNotebookUser.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            name,
          }
        );
        if (data.status === 200) {
          newItem = { ...newItem, id: data.id };
          setUsers([...users, newItem]);
          setItems([...items, newItem]);
          setNewItems([...newItems, newItem]);
          inputRef.current.value = "";
        }
      } catch (e) {
        console.log(e);
        if (e.status === 404) {
        }
      }
    } else {
      try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/notebook/createNotebookLocation.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
            name,
          }
        );
        if (data.status === 200) {
          newItem = { ...newItem, id: data.id };
          setLocations([...locations, newItem]);
          setItems([...items, newItem]);
          setNewItems([...newItems, newItem]);
          inputRef.current.value = "";
        }
      } catch (e) {
        console.log(e);
        if (e.status === 404) {
        }
      }
    }
  };

  const handleCheckbox = (e) => {
    const checkbox = e.currentTarget;
    checkbox.classList.toggle("exist");
  };

  useEffect(() => {
    if (items.length === 0) return;
    setItemHeight();
    const modalItems =
      wrapperRef.current.querySelectorAll(".adding-modal-item");
    modalItems[modalItems.length - 1].scrollIntoView();
    return () => window.removeEventListener("resize", setItemHeight);
  }, [items]);

  return (
    <div className="adding-modal">
      <div className="adding-modal-items-wrapper" ref={wrapperRef}>
        <div className="adding-modal-items">
          {items.map((item, index) => {
            const { name, fromLocation } = item;
            const exists = checkIfItemExists(name);
            return (
              <article key={index} className="adding-modal-item">
                <img src={getIcon(fromLocation)} alt="" />
                <span className="adding-modal-item-name">{name}</span>
                <div
                  className={
                    exists
                      ? "adding-modal-item-checkbox exist"
                      : "adding-modal-item-checkbox"
                  }
                  onClick={handleCheckbox}
                />
              </article>
            );
          })}
        </div>
      </div>
      <div className="adding-modal-input">
        <input type="text" ref={inputRef} />
        <div className="adding-modal-input-icon" onClick={addNewItem}>
          <img src={plusIcon} alt="" />
        </div>
      </div>
      <div className="adding-modal-button" onClick={addItems}>
        <img src={sendIcon} alt="" />
      </div>
    </div>
  );
};

export default AddingModal;
